<div class="dialog-container">
  <h1 mat-dialog-title>Clone a Trigger</h1>
  <div mat-dialog-content>
    <span *ngIf="cloning">
      <mat-progress-spinner mode="indeterminate" [diameter]="35"></mat-progress-spinner>
    </span>
    <div *ngIf="!loading && !cloning">
      <form #cloneForm="ngForm">
        <mat-form-field>
          <input
            appMin
            appMax
            #numOfCopies="ngModel"
            name="numOfCopies"
            [(ngModel)]="model.numOfCopies"
            matInput
            max="500"
            min="1"
          />
          <mat-error *ngIf="numOfCopies.invalid && (numOfCopies.dirty || numOfCopies.touched)">
            <div *ngIf="numOfCopies.errors.required">Number of copies is required.</div>
            <div *ngIf="numOfCopies.errors.max">Number of copies must be greater than 500.</div>
            <div *ngIf="numOfCopies.errors.min">Number of copies must be more than 0.</div>
          </mat-error>
        </mat-form-field>
        <div class="checkbox-container">
          <label class="label">What actions would you like to clone?</label>
          <div class="action-container">
            <mat-checkbox
              (change)="toggleAllSelected($event)"
              #selectAll="ngModel"
              name="selectAll"
              [(ngModel)]="model.allSelected"
            >
              <span *ngIf="!model.allSelected">Select all</span>
              <span *ngIf="model.allSelected">Deselect all</span>
            </mat-checkbox>
          </div>
          <div class="action-container" *ngFor="let action of actions">
            <mat-checkbox [checked]="action.selected" (change)="selectAction($event, action)">{{
              action.friendlyName
            }}</mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div mat-dialog-actions="" *ngIf="!loading">
    <button [disabled]="cloning" mat-button mat-dialog-close>Cancel</button>
    <button [disabled]="cloning" mat-raised-button (click)="create()">Create</button>
  </div>
</div>
